export default {
  'contract.list_title.list': 'Contract List',
  'contract.add.title': 'Add Contract',
  'contract.update.success': 'Successfully updated Contract',
  'contract.field.type': 'Type',
  'contract.field.code': 'Code',
  'contract.field.sales': 'Sales',
  'contract.field.contact': 'Contact',
  'contract.field.start_date': 'Start Date',
  'contract.field.end_date': 'End Date',
  'contract.field.remark': 'Remark',
  'contract.field.name': 'Contract Title',
  'contract.field.title': 'Contract Title',
  'contract.field.name.required': 'Please enter contract title',
  'contract.field.self_title': 'Self Title',
  'contract.field.contact_title': 'Contact Title',
  'contract.field.creator': 'Creator',
  'contract.field.document': 'Documents',
  'contract.field.list': 'Contracts',
  'contract.create.success': 'Successfully Create Contract',
  'contract.status.requested': 'Requested Contract',
  'contract.status.added': 'Added Contract',
  'contract.field.start_date.required': 'Please select start date',
  'contract.field.end_date.required': 'Please select end date',
  'contract.delete.confirm.title': 'Are you sure you want to delete this contract?',
  'contract.delete.success': 'Successfully Delete Contract',
  'contract.field.contact.required': 'Please select contact',
  'contract.tab.memos': 'Memos',
  'contract.tab.status': 'Status',
  'contract.tab.documents': 'Documents',
  'contract.tab.info': 'Info',
  'contract.submit.confirm': 'Are you sure you want to submit this contract?',
  'contract.unsubmit.confirm': 'Are you sure you want to unsubmit this contract?',
  'contract.deleted.title': 'Are you sure delete this contract',
  'contract.deleted.cannot_undo': 'This action cannot be undone.',
  'contract.deleted.cancel': 'Delete',
  'contract.submit.success': 'Successfully Submit Contract',
  'contract.unsubmit.success': 'Successfully Unsubmit Contract',
  'contract.deleted.success': 'Successfully Delete Contract',
  'contract.submit': 'Submit',
  'contract.unsubmit': 'Unsubmit',
  'contract.delete': 'Delete',
  'contract.submit.title': 'Submit Contract',
  'contract.unsubmit.title': 'Unsubmit Contract',
  'contract.delete.title': 'Delete Contract',
  'contract.menu.new': 'New Contract',
  'contract.field.status': 'Status',
  'contract.field.settlement_type': 'Settlement Type',

  // Settlement type options
  'contract.settlement_type.monthly': 'Monthly Settlement',
  'contract.settlement_type.weekly': 'Weekly Settlement',
  'contract.settlement_type.per_invoice': 'Per Invoice Settlement',
  'contract.settlement_type.quarterly': 'Quarterly Settlement',
  'contract.settlement_type.semi_annual': 'Semi-annual Settlement',
  'contract.settlement_type.annual': 'Annual Settlement',
  'contract.settlement_type.prepaid': 'Prepaid Settlement',
  'contract.field.submitted_at': 'Submitted At',
  'contract.field.created_at': 'Created At',
  'contract.field.reconcile_date': 'Reconcile Date',
  'contract.field.settlement_date': 'Settlement Date',
  'contract.field.settlement_requirement': 'Settlement Requirement',
};
